export const Withdraw_uischema = {
  pageTitle: {
    text: "Withdraw Application",
  },
  pageInfo: {
    // text:"Please use the dropdown below to select a reason documenting your withdrawal request.",
    text: `Please note that submitting this will change the status of your application to Withdrawn. An application in Withdrawn status cannot be reinstated for further processing.<br><br>
    <span style="color:#B50906">If you are withdrawing a case from Supervised Recruitment, please be aware that while the employer may file a "NEW" labor certification application meeting all regulatory requirements at any time, "ANY" future application for the same foreign worker and the same job opportunity as in the withdrawn application referenced above will be required to undergo mandatory supervised recruitment.</span>`,
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "withdrawal_reason",
          widget: "select",
          label: "Withdraw Reason",
          selection: [
            "Foreign Worker Deceased",
            "Multiple Filing Application in Process",
            "Multiple Filing Application pending with the Board of Alien Labor Certification (BALCA)",
            "Foreign Worker Terminated",
            "Employer Error in Application Submission",
            "Job Opportunity No Longer Available",
            "Position Filled by US Worker",
            "Other (Please Describe in Notes Section)",
          ],
          value: "- Select -",
          tooltip: `Please use the dropdown below to select a reason documenting your withdrawal request.`,
          validate: ["required"],
        },
        {
          machine_name: "case_note",
          widget: "text_area",
          label: "Notes (Other):",
          validate: ["required"],
          inputLimit: 500,
          rows: 7,
          isVisible: {
            when: "withdrawal_reason",
            is: "Other (Please Describe in Notes Section)",
          },
        },
      ],
    },
  ],
};
